module.exports = __webpack_public_path__ + "img/modeling_build.d25bcbfa.png";